import React from 'react';

const MeasurementContext = React.createContext();

export default MeasurementContext;